import { Component } from "vue";

import OssFolder from "../components/icons/OssFolder.vue";
import OssZTill from "../components/icons/OssZTill.vue";
import OssDashboard from "../components/icons/OssDashboard.vue";
import OssAnalysis from "../components/icons/OssAnalysis.vue";
import OssArchives from "../components/icons/OssArchives.vue";
import OssBank from "../components/icons/OssBank.vue";
import OssBarChart from "../components/icons/OssBarChart.vue";
import OssInvoice from "../components/icons/OssInvoice.vue";
import OssExpenseReport from "../components/icons/OssExpenseReport.vue";
import OssTVA from "../components/icons/OssTVA.vue";
import OssImport from "../components/icons/OssImport.vue";
import OssExport from "../components/icons/OssExport.vue";
import OssState from "../components/icons/OssState.vue";
import OssClose from "../components/icons/OssClose.vue";
import OssOutlinedUser from "../components/icons/OssOutlinedUser.vue";
import OssOutlinedHome from "../components/icons/OssOutlinedHome.vue";
import OssOutlinedPlay from "../components/icons/OssOutlinedPlay.vue";
import OssOutlinedTimeUser from "../components/icons/OssOutlinedTimeUser.vue";
import OssDownload from "../components/icons/OssDownload.vue";
import OssTrash from "../components/icons/OssTrash.vue";
import OssCalendar from "../components/icons/OssCalendar.vue";
import OssZoomIn from "../components/icons/OssZoomIn.vue";
import OssZoomOut from "../components/icons/OssZoomOut.vue";
import OssFocus from "../components/icons/OssFocus.vue";
import OssCircleCheck from "../components/icons/OssCircleCheck.vue";
import OssCircleUncheck from "../components/icons/OssCircleUncheck.vue";
import OssWarning from "../components/icons/OssWarning.vue";
import OssChat from "../components/icons/OssChat.vue";
import OssEdit from "../components/icons/OssEdit.vue";
// import OssChevronRight from "../components/icons/OssChevronRight.vue";
import OssDuplicate from "../components/icons/OssDuplicate.vue";
import OssUpload from "../components/icons/OssUpload.vue";
import OssCar from "../components/icons/OssCar.vue";
import OssMail from "../components/icons/OssMail.vue";
import OssMoto from "../components/icons/OssMoto.vue";
import OssMotorCycle from "../components/icons/OssMotorCycle.vue";
import OssHelp from "../components/icons/OssHelp.vue";
import OssFile from "../components/icons/OssFile.vue";
// import OssChevronLeft from "../components/icons/OssChevronLeft.vue";
import OssEyeSlash from "../components/icons/OssEyeSlash.vue";
import OssEye from "../components/icons/OssEye.vue";
import OssRightArrow from "../components/icons/OssRightArrow.vue";
import OssLetter from "../components/icons/OssLetter.vue";
import OssAlreadyDownloaded from "../components/icons/OssAlreadyDownloaded.vue";
import OssAdjust from "../components/icons/OssAdjust.vue";
import OssAccountingPlan from "../components/icons/OssAccountingPlan.vue";
import OssExportOutlined from "../components/icons/OssExportOutlined.vue";
import OssCompany from "../components/icons/OssCompany.vue";
import OssGeneralLedger from "../components/icons/OssGeneralLedger.vue";
import OssPaperClip from "../components/icons/OssPaperClip.vue";
import OssNew from "../components/icons/OssNew.vue";
import OssEuroChange from "../components/icons/OssEuroChange.vue";
import OssPercentageChange from "../components/icons/OssPercentageChange.vue";
import OssSync from "../components/icons/OssSync.vue";
import OssChatFilled from "../components/icons/OssChatFilled.vue";
import OssUserCard from "../components/icons/OssUserCard.vue";
import OssChristmasTree from "../components/icons/OssChristmasTree.vue";
import OssBell from "../components/icons/OssBell.vue";
import OssAccountingLines from "../components/icons/OssAccountingLines.vue";
import OssActivity from "../components/icons/OssActivity.vue";
import OssScan from "../components/icons/OssScan.vue";
import OssDisconnect from "../components/icons/OssDisconnect.vue";
import OssBicycle from "../components/icons/OssBicycle.vue";
import OssInsertAfter from "../components/icons/OssInsertAfter.vue";
import OssFormatVerticalAlignTop from "../components/icons/OssFormatVerticalAlignTop.vue";
// import faChevronRight from "@/components/icons/faChevronRight.vue";
// import faChevronLeft from "@/components/icons/faChevronLeft.vue";
import faComments from "@/components/icons/faComments.vue";
import faSearchPlus from "@/components/icons/faSearchPlus.vue";
import faEquals from "@/components/icons/faEquals.vue";
import faPlug from "@/components/icons/faPlug.vue";
import FaEraser from "@/components/icons/faEraser.vue";
import FaEye from "@/components/icons/faEye.vue";
import FaCloudDownloadAlt from "@/components/icons/faCloudDownloadAlt.vue";
import FaThumbsUp from "@/components/icons/faThumbsUp.vue";
import FaThumbsDown from "@/components/icons/faThumbsDown.vue";
import FaEuroSign from "../components/icons/faEuroSign.vue";
import FaUniversity from "@/components/icons/faUniversity.vue";
import FaCashRegister from "@/components/icons/faCashRegister.vue";
import FaMagic from "@/components/icons/faMagic.vue";
import FaUser from "@/components/icons/faUser.vue";
import FaQuestionCircle from "@/components/icons/faQuestionCircle.vue";
import FaCreditCard from "@/components/icons/faCreditCard.vue";
import FaMoneyBillWave from "@/components/icons/faMoneyBillWave.vue";
import FaMoneyCheck from "@/components/icons/faMoneyCheck.vue";
import FaExchangeAlt from "@/components/icons/faExchangeAlt.vue";
import FaFileUpload from "@/components/icons/faFileUpload.vue";
import FaCheckCircle from "@/components/icons/faCheckCircle.vue";
import FaChartBar from "@/components/icons/faChartBar.vue";
import FaPercentage from "@/components/icons/faPercentage.vue";
import FaTrashAlt from "@/components/icons/faTrashAlt.vue";
import FaSearchMinus from "@/components/icons/faSearchMinus.vue";
import FaCaretUp from "@/components/icons/faCaretUp.vue";
import FaCheckSquare from "@/components/icons/faCheckSquare.vue";
import FaSquare from "@/components/icons/faSquare.vue";
import FaExclamationTriangle from "@/components/icons/faExclamationTriangle.vue";
import FaCheck from "@/components/icons/faCheck.vue";
import FaCaretDown from "@/components/icons/faCaretDown.vue";
import FaReceipt from "@/components/icons/faReceipt.vue";
import FaDropBox from "@/components/icons/faDropBox.vue";
import FaPlusCircle from "@/components/icons/faPlusCircle.vue";
import FaSearch from "@/components/icons/faSearch.vue";
import FaFileExcel from "@/components/icons/faFileExcel.vue";
import FaFileWord from "@/components/icons/faFileWord.vue";
import FaFilePdf from "@/components/icons/faFilePdf.vue";
import FaTimes from "@/components/icons/faTimes.vue";
import FaChevronDown from "@/components/icons/faChevronDown.vue";
import FaChevronUp from "@/components/icons/faChevronUp.vue";
import FaShare from "@/components/icons/faShare.vue";
import FaPlus from "@/components/icons/faPlus.vue";
import FaCircle from "@/components/icons/faCircle.vue";
import FaArrowLeft from "@/components/icons/faArrowLeft.vue";
import FaArrowRightLeft from "@/components/icons/faArrowRightLeft.vue";
import FaMinus from "@/components/icons/faMinus.vue";
import FaDatabase from "@/components/icons/faDatabase.vue";
import FaTable from "@/components/icons/faTable.vue";
import FaFileInvoice from "@/components/icons/faFileInvoice.vue";
import FaFileContract from "@/components/icons/faFileContract.vue";
import FaCheckDouble from "@/components/icons/faCheckDouble.vue";
import FaQuestion from "@/components/icons/faQuestion.vue";
import FaCut from "@/components/icons/faCut.vue";
import FaGlobeEurope from "@/components/icons/faGlobeEurope.vue";
import FaFileAlt from "@/components/icons/faFileAlt.vue";
import FaVideo from "@/components/icons/faVideo.vue";
import FaRedoAlt from "@/components/icons/faRedoAlt.vue";
import FaSitemap from "@/components/icons/faSitemap.vue";
import FaListUl from "@/components/icons/faListUl.vue";
import FaBullseye from "@/components/icons/faBullseye.vue";
import FaBuilding from "@/components/icons/faBuilding.vue";
import FaEyeSlash from "@/components/icons/faEyeSlash.vue";
import FaHome from "@/components/icons/faHome.vue";
import FaChartLine from "@/components/icons/faChartLine.vue";
import FaVial from "@/components/icons/faVial.vue";
import FaStar from "@/components/icons/faStar.vue";
import FarFaStar from "@/components/icons/farFaStar.vue";
import FaKey from "@/components/icons/faKey.vue";
import FaEdit from "@/components/icons/faEdit.vue";
import FaSyncAlt from "@/components/icons/faSyncAlt.vue";
import FaAngleUp from "@/components/icons/faAngleUp.vue";
import FaAngleDown from "@/components/icons/faAngleDown.vue";
import FaTrash from "@/components/icons/faTrash.vue";
import FaBan from "@/components/icons/faBan.vue";
import FaClone from "@/components/icons/faClone.vue";
import FaUnlink from "@/components/icons/faUnlink.vue";
import FaChartPie from "@/components/icons/faChartPie.vue";
import FaSpellCheck from "@/components/icons/faSpellCheck.vue";
import FaHistory from "@/components/icons/faHistory.vue";
import FaUserEdit from "@/components/icons/faUserEdit.vue";
import FaUserCog from "@/components/icons/faUserCog.vue";
import FaHandHoldingUsd from "@/components/icons/faHandHoldingUsd.vue";
import FaPhotoVideo from "@/components/icons/faPhotoVideo.vue";
import FaFolder from "@/components/icons/faFolder.vue";
import FaList from "@/components/icons/faList.vue";
import FaLock from "@/components/icons/faLock.vue";
import FaInfoCircle from "@/components/icons/faInfoCircle.vue";
import MoreVert from "@/components/icons/moreVert.vue";
import Add from "@/components/icons/add.vue";
import Remove from "@/components/icons/remove.vue";
import Star from "@/components/icons/star.vue";
import SubdirectoryArrowRight from "@/components/icons/subdirectoryArrowRight.vue";
import Check from "@/components/icons/check.vue";
// import ChevronRight from "@/components/icons/chevronRight.vue";
// import creditCard from "../components/icons/creditCard.vue";
import Delete from "@/components/icons/delete.vue";
import NavigateBefore from "@/components/icons/navigateBefore.vue";
import NavigateNext from "@/components/icons/navigateNext.vue";
import Edit from "@/components/icons/edit.vue";
import LockOutline from "@/components/icons/lockOutline.vue";
import Bookmark from "@/components/icons/bookmark.vue";
import Home from "@/components/icons/home.vue";
// import KeyboardArrowLeft from "@/components/icons/keyboardArrowLeft.vue";
// import KeyboardArrowRight from "@/components/icons/keyboardArrowRight.vue";
import ArrowBackIos from "@/components/icons/arrowBackIos.vue";
import Tune from "@/components/icons/tune.vue";
import CheckCircle from "@/components/icons/checkCircle.vue";
import Stop from "@/components/icons/stop.vue";
import Clear from "@/components/icons/clear.vue";
import Close from "@/components/icons/close.vue";
import HighlightOff from "@/components/icons/highlightOff.vue";
import OssArticle from "@/components/icons/article.vue";
import DateRange from "@/components/icons/dateRange.vue";
import Gavel from "@/components/icons/gavel.vue";
import AccountBalanceWallet from "@/components/icons/accountBalanceWallet.vue";
import Storefront from "@/components/icons/storefront.vue";
import LabelOutline from "@/components/icons/labelOutline.vue";
import CheckCircleOutline from "@/components/icons/checkCircleOutline.vue";
import Label from "@/components/icons/label.vue";
import ChatBubble from "@/components/icons/chatBubble.vue";
import ListAlt from "@/components/icons/listAlt.vue";
import Storage from "@/components/icons/storage.vue";
import FiberNew from "@/components/icons/fiberNew.vue";
import List from "@/components/icons/list.vue";
import GridView from "@/components/icons/gridView.vue";
import Spellcheck from "@/components/icons/spellcheck.vue";
import Warning from "@/components/icons/warning.vue";
import ChevronLeft from "@/components/icons/chevronLeft.vue";
import Dot from "@/components/icons/dot.vue";
import Euro from "@/components/icons/euro.vue";
import Error from "@/components/icons/error.vue";
import LiveHelp from "@/components/icons/liveHelp.vue";
import LinkOff from "@/components/icons/linkOff.vue";
import Build from "@/components/icons/build.vue";
import HourglassEmpty from "@/components/icons/hourglassEmpty.vue";
import ZoomOut from "@/components/icons/zoomOut.vue";
import CenterFocusWeak from "@/components/icons/centerFocusWeak.vue";
import ZoomIn from "@/components/icons/zoomIn.vue";
import CompareArrows from "@/components/icons/compareArrows.vue";
import DeleteOutline from "@/components/icons/deleteOutline.vue";
import AttachFile from "@/components/icons/attachFile.vue";
import AddToDrive from "@/components/icons/addToDrive.vue";
import DirectionsCar from "@/components/icons/directionsCar.vue";
import CheckBoxOutlineBlank from "@/components/icons/checkBoxOutlineBlank.vue";
import CheckBox from "@/components/icons/checkBox.vue";
import CheckBoxIndeterminate from "@/components/icons/checkBoxIndeterminate.vue";
import MenuDown from "@/components/icons/menuDown.vue";
import Person from "@/components/icons/person.vue";
import FaThList from "@/components/icons/faThList.vue";
import CloudDownload from "@/components/icons/cloudDownload.vue";
import RadioButtonChecked from "@/components/icons/radioButtonChecked.vue";
import RadioButtonUnchecked from "@/components/icons/radioButtonUnchecked.vue";
import FaDotCircle from "@/components/icons/faDotCircle.vue";
import FaEnvelope from "@/components/icons/faEnvelope.vue";
import FaEnvelopeOpen from "@/components/icons/faEnvelopeOpen.vue";
import FaAlignLeft from "@/components/icons/faAlignLeft.vue";
import FaAlignRight from "@/components/icons/faAlignRight.vue";
import FaAlignCenter from "@/components/icons/faAlignCenter.vue";
import FaAlignJustify from "@/components/icons/faAlignJustify.vue";
import FaUpload from "@/components/icons/faUpload.vue";
import FaGripVertical from "@/components/icons/faGripVertical.vue";
import FaWrench from "@/components/icons/faWrench.vue";
import FaFilter from "@/components/icons/faFilter.vue";
import FaSort from "@/components/icons/faSort.vue";
import FaSortUp from "@/components/icons/faSortUp.vue";
import FaSortDown from "@/components/icons/faSortDown.vue";
import Assessment from "@/components/icons/assessment.vue";
import TrendingUp from "@/components/icons/trendingUp.vue";
import TrendingDown from "@/components/icons/trendingDown.vue";
import KeyboardTab from "@/components/icons/keyboardTab.vue";
import Rule from "@/components/icons/rule.vue";
import ReportProblem from "@/components/icons/reportProblem.vue";
import RemoveRedEye from "@/components/icons/removeRedEye.vue";
import Refresh from "@/components/icons/refresh.vue";
import Apartment from "@/components/icons/apartment.vue";
import Store from "@/components/icons/store.vue";
import KeyboardArrowDown from "@/components/icons/keyboardArrowDown.vue";
import KeyboardArrowUp from "@/components/icons/keyboardArrowUp.vue";
import IndeterminateCheckBox from "@/components/icons/indeterminateCheckBox.vue";
import Create from "@/components/icons/create.vue";
import LabelImportant from "@/components/icons/labelImportant.vue";
import AvTimer from "@/components/icons/avTimer.vue";
import Receipt from "@/components/icons/receipt.vue";
import Link from "@/components/icons/link.vue";
import FaBook from "@/components/icons/faBook.vue";
import FaBusinessTime from "@/components/icons/faBusinessTime.vue";
import FaUndo from "@/components/icons/faUndo.vue";
import FaRedo from "@/components/icons/faRedo.vue";
import FaAtlas from "@/components/icons/faAtlas.vue";
import FaShoePrints from "@/components/icons/faShoePrints.vue";
import FaGear from "@/components/icons/faGear.vue";
import FaColumns from "@/components/icons/faColumns.vue";
import Bell from "@/components/icons/bell.vue";
import Alert from "@/components/icons/alert.vue";
import BellAlert from "@/components/icons/bellAlert.vue";
// import DotsVertical from "@/components/icons/dotsVertical.vue";
import businessCenter from "@/components/icons/businessCenter.vue";
import Send from "@/components/icons/send.vue";
import FaHourglassHalf from "@/components/icons/faHourglassHalf.vue";
import MdiEye from "@/components/icons/mdiEye.vue";
import MdiRadioboxMarked from "@/components/icons/mdiRadioboxMarked.vue";
import MdiRadioboxBlank from "@/components/icons/mdiRadioboxBlank.vue";
import NotEqual from "@/components/icons/notEqual.vue";
import FaSync from "@/components/icons/faSync.vue";
import AddCircleOutline from "@/components/icons/addCircleOutline.vue";
import Comment from "@/components/icons/comment.vue";
import FaEllipsisV from "@/components/icons/faEllipsisV.vue";
import FaBars from "@/components/icons/faBars.vue";
import FaTableCellsLarge from "@/components/icons/faTableCellsLarge.vue";
import FaBorderAll from "@/components/icons/faBorderAll.vue";
import FaStepForward from "@/components/icons/faStepForward.vue";
import FaStepBackward from "@/components/icons/faStepBackward.vue";
import FaForward from "@/components/icons/faForward.vue";
import FaBackward from "@/components/icons/faBackward.vue";
import FaCopy from "@/components/icons/faCopy.vue";
import FaCalendarAlt from "@/components/icons/faCalendarAlt.vue";
import FaObjectUngroup from "@/components/icons/faObjectUngroup.vue";
import FaTachometerAlt from "@/components/icons/faTachometerAlt.vue";
import FaAngleDoubleRight from "@/components/icons/faAngleDoubleRight.vue";
import FaFileInvoiceDollar from "@/components/icons/faFileInvoiceDollar.vue";
import Business from "@/components/icons/business.vue";
import ShoppingCart from "../components/icons/shoppingCart.vue";
import FaFileImport from "@/components/icons/faFileImport.vue";
import FaFileExport from "@/components/icons/faFileExport.vue";
import FaEyeLowVision from "@/components/icons/FaEyeLowVision.vue";
import NoteFrais from "@/components/icons/noteFrais.vue";
import FaRetweet from "@/components/icons/faRetweet.vue";
import OssFastForward from "@/components/icons/OssFastForward.vue";

const aliases: Record<string, Component> = {
    collapse: FaChevronUp,
    expand: FaChevronDown,
    checkboxOff: CheckBoxOutlineBlank,
    checkboxOn: CheckBox,
    checkboxIndeterminate: CheckBoxIndeterminate,
    dropdown: MenuDown,
    subgroup: MenuDown,
    radioOff: RadioButtonUnchecked,
    radioOn: RadioButtonChecked,
    next: NavigateNext,
    prev: NavigateBefore,

    "oss-folder": OssFolder,
    "oss-ztill": OssZTill,
    "oss-dashboard": OssDashboard,
    "oss-already-downloaded": OssAlreadyDownloaded,
    "oss-analysis": OssAnalysis,
    "oss-archives": OssArchives,
    "oss-bank": OssBank,
    "oss-bar-chart": OssBarChart,
    "oss-invoice": OssInvoice,
    "oss-expense-report": OssExpenseReport,
    "oss-tva": OssTVA,
    "oss-import": OssImport,
    "oss-export": OssExport,
    "oss-state": OssState,
    "oss-close": OssClose,
    "oss-outlined-user": OssOutlinedUser,
    "oss-outlined-home": OssOutlinedHome,
    "oss-outlined-play": OssOutlinedPlay,
    "oss-outlined-time-user": OssOutlinedTimeUser,
    "oss-download": OssDownload,
    "oss-trash": OssTrash,
    "oss-calendar": OssCalendar,
    "oss-zoom-in": OssZoomIn,
    "oss-zoom-out": OssZoomOut,
    "oss-focus": OssFocus,
    "oss-circle-check": OssCircleCheck,
    "oss-circle-uncheck": OssCircleUncheck,
    "oss-warning": OssWarning,
    "oss-chat": OssChat,
    "oss-edit": OssEdit,
    "oss-chevron-right": NavigateNext,
    "oss-duplicate": OssDuplicate,
    "oss-upload": OssUpload,
    "oss-car": OssCar,
    "oss-moto": OssMoto,
    "oss-motorcycle": OssMotorCycle,
    "oss-help": OssHelp,
    "oss-file": OssFile,
    "oss-chevron-left": NavigateBefore,
    "oss-eye-slash": OssEyeSlash,
    "oss-eye": OssEye,
    "oss-right-arrow": OssRightArrow,
    "oss-letter": OssLetter,
    "oss-adjust": OssAdjust,
    "oss-export-outlined": OssExportOutlined,
    "oss-accounting-plan": OssAccountingPlan,
    "oss-mail": OssMail,
    "oss-company": OssCompany,
    "oss-general-ledger": OssGeneralLedger,
    "oss-paper-clip": OssPaperClip,
    "oss-new": OssNew,
    "oss-euro-change": OssEuroChange,
    "oss-percentage-change": OssPercentageChange,
    "oss-sync": OssSync,
    "oss-chat-filled": OssChatFilled,
    "oss-user-card": OssUserCard,
    "oss-christmas-tree": OssChristmasTree,
    "oss-bell": OssBell,
    "oss-accounting-lines": OssAccountingLines,
    "oss-activity": OssActivity,
    "oss-scan": OssScan,
    "oss-disconnect": OssDisconnect,
    "oss-bicycle": OssBicycle,
    "oss-insert-after": OssInsertAfter,
    "oss-format-vertical-align-top": OssFormatVerticalAlignTop,
    "oss-accounting-line": OssAccountingLines,
    "oss-fast-forward": OssFastForward,
    "fa-chevron-right": NavigateNext,
    "fa-chevron-left": ChevronLeft,
    "fa-comments": faComments,
    "fa-search-plus": faSearchPlus,
    "fa-equals": faEquals,
    "fa-plug": faPlug,
    "fa-eraser": FaEraser,
    "fa-eye": FaEye,
    "fa-cloud-download-alt": FaCloudDownloadAlt,
    "fa-thumbs-up": FaThumbsUp,
    "fa-thumbs-down": FaThumbsDown,
    "fa-euro-sign": FaEuroSign,
    "fa-university": FaUniversity,
    "fa-cash-register": FaCashRegister,
    "fa-magic": FaMagic,
    "fa-user": FaUser,
    "fa-question-circle": FaQuestionCircle,
    "fa-credit-card": FaCreditCard,
    "fa-money-bill-wave": FaMoneyBillWave,
    "fa-money-check": FaMoneyCheck,
    "fa-exchange-alt": FaExchangeAlt,
    "fa-file-upload": FaFileUpload,
    "fa-check-circle": FaCheckCircle,
    "fa-chart-bar": FaChartBar,
    "fa-percentage": FaPercentage,
    "fa-trash-alt": FaTrashAlt,
    "fa-search-minus": FaSearchMinus,
    "fa-caret-up": FaCaretUp,
    "fa-check-square": FaCheckSquare,
    "fa-square": FaSquare,
    "fa-exclamation-triangle": FaExclamationTriangle,
    "fa-check": FaCheck,
    "fa-caret-down": FaCaretDown,
    "fa-receipt": FaReceipt,
    "fa-plus-circle": FaPlusCircle,
    "fa-search": FaSearch,
    "fa-file-excel": FaFileExcel,
    "fa-file-word": FaFileWord,
    "fa-file-pdf": FaFilePdf,
    "fa-times": FaTimes,
    "fa-chevron-down": FaChevronDown,
    "fa-chevron-up": FaChevronUp,
    "fa-share": FaShare,
    "fa-plus": FaPlus,
    "fa-circle": FaCircle,
    "fa-arrow-left": FaArrowLeft,
    "fa-arrow-right-left": FaArrowRightLeft,
    "fa-minus": FaMinus,
    "fa-database": FaDatabase,
    "fa-table": FaTable,
    "fa-file-invoice": FaFileInvoice,
    "fa-file-contract": FaFileContract,
    "fa-check-double": FaCheckDouble,
    "fa-question": FaQuestion,
    "fa-cut": FaCut,
    "fa-globe-europe": FaGlobeEurope,
    "fa-file-alt": FaFileAlt,
    "fa-video": FaVideo,
    "fa-redo-alt": FaRedoAlt,
    "fa-sitemap": FaSitemap,
    "fa-list-ul": FaListUl,
    "fa-bullseye": FaBullseye,
    "fa-building": FaBuilding,
    "fa-eye-slash": FaEyeSlash,
    "fa-eye-low-vision": FaEyeLowVision,
    "fa-home": FaHome,
    "fa-chart-line": FaChartLine,
    "fa-vial": FaVial,
    "fa-star": FaStar,
    "far-fa-star": FarFaStar,
    "fa-key": FaKey,
    "fa-edit": FaEdit,
    "fa-sync-alt": FaSyncAlt,
    "fa-sync": FaSync,
    "fa-angle-up": FaAngleUp,
    "fa-angle-down": FaAngleDown,
    "fa-trash": FaTrash,
    "fa-ban": FaBan,
    "fa-clone": FaClone,
    "business-center": businessCenter,
    business: Business,
    "fa-unlink": FaUnlink,
    "fa-chart-pie": FaChartPie,
    "fa-spell-check": FaSpellCheck,
    "fa-history": FaHistory,
    "fa-user-edit": FaUserEdit,
    "fa-user-cog": FaUserCog,
    "fa-hand-holding-usd": FaHandHoldingUsd,
    "fa-photo-video": FaPhotoVideo,
    "fa-folder": FaFolder,
    "fa-list": FaList,
    "fa-lock": FaLock,
    "fa-info-circle": FaInfoCircle,
    "fa-dropbox": FaDropBox,
    "shopping-cart": ShoppingCart,
    more_vert: MoreVert, // too light: replaced by dots_vertical
    add: Add,
    remove: Remove,
    star: Star,
    subdirectory_arrow_right: SubdirectoryArrowRight,
    check: Check,
    chevron_right: NavigateNext,
    delete: Delete,
    navigate_before: NavigateBefore,
    navigate_next: NavigateNext,
    edit: Edit,
    lock_outline: LockOutline,
    bookmark: Bookmark,
    home: Home,
    keyboard_arrow_left: NavigateBefore,
    keyboard_arrow_right: NavigateNext,
    arrow_back_ios: ArrowBackIos,
    tune: Tune,
    check_circle: CheckCircle,
    stop: Stop,
    clear: Clear,
    close: Close,
    highlight_off: HighlightOff,
    "oss-article": OssArticle,
    date_range: DateRange,
    gavel: Gavel,
    account_balance_wallet: AccountBalanceWallet,
    storefront: Storefront,
    label_outline: LabelOutline,
    check_circle_outline: CheckCircleOutline,
    label: Label,
    labl_icon: Label,
    chat_bubble: ChatBubble,
    list_alt: ListAlt,
    storage: Storage,
    fiber_new: FiberNew,
    list: List,
    grid_view: GridView,
    spellcheck: Spellcheck,
    warning: Warning,
    "chevron-left": NavigateBefore,
    euro: Euro,
    error: Error,
    live_help: LiveHelp,
    link_off: LinkOff,
    build: Build,
    hourglass_empty: HourglassEmpty,
    zoom_out: ZoomOut,
    center_focus_weak: CenterFocusWeak,
    zoom_in: ZoomIn,
    compare_arrows: CompareArrows,
    delete_outline: DeleteOutline,
    attach_file: AttachFile,
    add_to_drive: AddToDrive,
    directions_car: DirectionsCar,
    check_box_outline_blank: CheckBoxOutlineBlank,
    check_box: CheckBox,
    person: Person,
    "fa-th-list": FaThList,
    cloud_download: CloudDownload,
    dot: Dot,
    "fa-dot-circle": FaDotCircle,
    "fa-envelope-open": FaEnvelopeOpen,
    "fa-envelope": FaEnvelope,
    "fa-align-left": FaAlignLeft,
    "fa-align-right": FaAlignRight,
    "fa-align-center": FaAlignCenter,
    "fa-align-justify": FaAlignJustify,
    "fa-upload": FaUpload,
    "fa-grip-vertical": FaGripVertical,
    "fa-wrench": FaWrench,
    radio_button_checked: RadioButtonChecked,
    radio_button_unchecked: RadioButtonUnchecked,
    search: FaSearch,
    "fa-filter": FaFilter,
    "fa-sort": FaSort,
    "fa-sort-up": FaSortUp,
    "fa-sort-down": FaSortDown,
    assessment: Assessment,
    trending_up: TrendingUp,
    trending_down: TrendingDown,
    keyboard_tab: KeyboardTab,
    rule: Rule,
    report_problem: ReportProblem,
    remove_red_eye: RemoveRedEye,
    refresh: Refresh,
    apartment: Apartment,
    store: Store,
    keyboard_arrow_down: KeyboardArrowDown,
    keyboard_arrow_up: KeyboardArrowUp,
    indeterminate_check_box: IndeterminateCheckBox,
    create: Create,
    labl_important: LabelImportant,
    av_timer: AvTimer,
    receipt: Receipt,
    link: Link,
    "fa-book": FaBook,
    send: Send,
    "fa-business-time": FaBusinessTime,
    "fa-undo": FaUndo,
    "fa-redo": FaRedo,
    "fa-retweet": FaRetweet,
    "fa-atlas": FaAtlas,
    "fa-shoe-prints": FaShoePrints,
    "fa-gear": FaGear,
    "fa-columns": FaColumns,
    "fa-hourglass-half": FaHourglassHalf,
    bell: Bell,
    alert: Alert,
    bell_alert: BellAlert,
    dots_vertical: MoreVert,
    "mdi-eye": MdiEye,
    "mdi-radiobox-marked": MdiRadioboxMarked,
    "mdi-radiobox-blank": MdiRadioboxBlank,
    "not-equal": NotEqual,
    add_circle_outline: AddCircleOutline,
    comment: Comment,
    "fa-ellipsis-v": FaEllipsisV,
    "fa-bars": FaBars,
    "fa-table-cells-large": FaTableCellsLarge,
    "fa-border-all": FaBorderAll,
    "fa-step-forward": FaStepForward,
    "fa-forward-step": FaStepForward,
    "fa-step-backward": FaStepBackward,
    "fa-backward-step": FaStepBackward,
    "fa-forward": FaForward,
    "fa-backward": FaBackward,
    "fa-copy": FaCopy,
    "fa-calendar-alt": FaCalendarAlt,
    "fa-object-ungroup": FaObjectUngroup,
    "fa-tachometer-alt": FaTachometerAlt,
    "fa-angle-double-right": FaAngleDoubleRight,
    "fa-file-invoice-dollar": FaFileInvoiceDollar,
    "fa-file-import": FaFileImport,
    "fa-file-export": FaFileExport,
    "note-frais": NoteFrais,
};

// const custom: IconSet = {
//   // component: (props: any) => {
//   //   return h(aliases[props.icon], props)
//   // }
// }

export { aliases };
